import { ShieldCheck, Clock, Sparkles, AlertCircle } from "lucide-react";

const base = "inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold";

export const ReviewBadge = ({ status = "pending_expert_review", testId = "review-badge" }) =>
  status === "expert_reviewed" ? (
    <span className={`${base} bg-teal-light text-teal border-teal/20`} data-testid={testId}><ShieldCheck className="h-3.5 w-3.5" aria-hidden="true" />Expert reviewed</span>
  ) : (
    <span className={`${base} bg-[#FFF4E5] text-[#8A5300] border-[#B76E00]/30`} data-testid={testId}><Clock className="h-3.5 w-3.5" aria-hidden="true" />Draft · pending expert review</span>
  );

export const FutureBadge = ({ label = "Not yet available", testId }) => (
  <span className={`${base} bg-cream-deep text-ink-soft border-ink/10`} data-testid={testId}><Sparkles className="h-3.5 w-3.5" aria-hidden="true" />{label}</span>
);

export const VerificationBadge = ({ entry }) =>
  entry.verification === "verified" ? (
    <span className={`${base} bg-sage-light text-sage-dark border-sage-dark/20`} data-testid={`verified-badge-${entry.slug}`}><ShieldCheck className="h-3.5 w-3.5" aria-hidden="true" />Details checked {entry.last_checked ? new Date(entry.last_checked).toLocaleDateString("en-GB", { month: "short", year: "numeric" }) : ""}</span>
  ) : (
    <span className={`${base} bg-[#FFF4E5] text-[#8A5300] border-[#B76E00]/30`} data-testid={`needs-review-badge-${entry.slug}`}><AlertCircle className="h-3.5 w-3.5" aria-hidden="true" />Awaiting verification</span>
  );
